import { env } from '@/env';
import * as Sentry from '@sentry/react';

Sentry.init({
  dsn: env.VITE_SENTRY_DSN,
  enableLogs: true,
  enabled: process.env.NODE_ENV === 'production',
  environment: import.meta.env.MODE,
  integrations: [
    Sentry.browserTracingIntegration(),
    Sentry.replayIntegration(),
    Sentry.consoleLoggingIntegration({ levels: ['log', 'warn', 'error'] }),
  ],
  // Tracing
  tracesSampleRate: 0.05, //  Capture 5% of the transactions
  // Set sampling rate for profiling - this is relative to tracesSampleRate
  profilesSampleRate: 1.0,
  replaysSessionSampleRate: 0.1,
  replaysOnErrorSampleRate: 1.0,
  sendDefaultPii: true
});
